import React from 'react';
import { Card, Col, Row, Statistic, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useControlTowerProductionRequests } from '@/hooks/useManufacturingControlTower';

const ProductionRequestCenter: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerProductionRequests();
  const d = data as {
    counts?: Record<string, number>;
    buckets?: Record<string, Array<{ id: string; request_number: string; status: string }>>;
  };

  return (
    <Card id="production-requests" title="Production request center (MTS)" style={{ marginTop: 16 }} loading={isLoading}>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        {['approved', 'in_production', 'ready_stock', 'blocked', 'completed'].map((k) => (
          <Col key={k} xs={12} sm={8} md={4}>
            <Statistic title={k.replace(/_/g, ' ')} value={d?.counts?.[k] ?? 0} />
          </Col>
        ))}
      </Row>
      <Table
        size="small"
        rowKey="id"
        dataSource={d?.buckets?.in_production ?? []}
        title={() => 'In production'}
        onRow={(r) => ({
          onClick: () => navigate(`/mfg/production-requests/${r.id}`),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'PR #', dataIndex: 'request_number' },
          { title: 'Status', dataIndex: 'status' },
        ]}
        pagination={false}
      />
    </Card>
  );
};

export default ProductionRequestCenter;
